/**
 * Zaoud mega menu — standalone navigation with animated panels.
 */
(function () {
  const nav = document.querySelector('[data-zaoud-mega-nav]');
  if (!nav) return;

  const items = nav.querySelectorAll('[data-zaoud-mega-item]');
  const allItems = nav.querySelectorAll('.zaoud-mega-nav__item');
  let activeItem = null;
  let closeTimer = null;
  const CLOSE_DELAY = 450;
  const PANEL_SETTLE_MS = 580;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const headerWrapper = nav.closest('.header-wrapper');

  const cancelClose = () => {
    clearTimeout(closeTimer);
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimer = setTimeout(closeAll, CLOSE_DELAY);
  };

  const resetPanelSettle = (item) => {
    item.classList.remove('is-panel-settled');
    if (item._settleTimer) {
      clearTimeout(item._settleTimer);
      item._settleTimer = null;
    }
  };

  const schedulePanelSettle = (item) => {
    resetPanelSettle(item);

    const panelBody = item.querySelector('.zaoud-mega-nav__panel-body');
    if (!panelBody || panelBody.classList.contains('zaoud-mega-nav__panel-body--simple')) {
      return;
    }

    if (prefersReducedMotion) {
      item.classList.add('is-panel-settled');
      return;
    }

    item._settleTimer = setTimeout(() => {
      if (item.classList.contains('is-open')) {
        item.classList.add('is-panel-settled');
      }
    }, PANEL_SETTLE_MS);
  };

  const closeAll = () => {
    items.forEach((item) => {
      const trigger = item.querySelector('.zaoud-mega-nav__trigger');
      const panel = item.querySelector('[data-zaoud-mega-panel]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');
      item.classList.remove('is-open');
      resetPanelSettle(item);
    });
    activeItem = null;
    nav.classList.remove('is-active');
    nav.classList.remove('is-active--mega');
  };

  const openItem = (item) => {
    if (activeItem === item) return;
    closeAll();

    const trigger = item.querySelector('.zaoud-mega-nav__trigger');
    const panel = item.querySelector('[data-zaoud-mega-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');

    // Ensure closed styles paint before opening so the entrance transition runs.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        item.classList.add('is-open');
        activeItem = item;
        nav.classList.add('is-active');

        if (
          item.dataset.panelType === 'mega' ||
          item.dataset.panelType === 'image-mega' ||
          item.dataset.panelType === 'collection-mega' ||
          item.dataset.panelType === 'split-mega'
        ) {
          nav.classList.add('is-active--mega');
        }

        schedulePanelSettle(item);
      });
    });
  };

  allItems.forEach((item) => {
    const trigger = item.querySelector('.zaoud-mega-nav__trigger');
    const panel = item.querySelector('[data-zaoud-mega-panel]');
    const hasPanel = item.hasAttribute('data-zaoud-mega-item') && panel;

    if (!trigger) return;

    item.addEventListener('mouseenter', () => {
      cancelClose();
      if (hasPanel) {
        openItem(item);
      } else {
        /* Leaf links (no children) should close any open mega panel. */
        closeAll();
      }
    });

    if (!hasPanel) {
      trigger.addEventListener('focus', closeAll);
      return;
    }

    const panelType = item.dataset.panelType;
    const isFullPanel =
      panelType === 'mega' ||
      panelType === 'image-mega' ||
      panelType === 'collection-mega' ||
      panelType === 'split-mega';

    // Narrow <li> boxes do not cover the panel — only close on item leave for compact dropdowns.
    if (!isFullPanel) {
      item.addEventListener('mouseleave', scheduleClose);
    }

    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('mouseenter', cancelClose);

    trigger.addEventListener('focus', () => openItem(item));

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAll();
        trigger.blur();
      }
    });
  });

  nav.querySelectorAll('.zaoud-mega-nav__panel-backdrop').forEach((backdrop) => {
    backdrop.addEventListener('mouseenter', cancelClose);
    backdrop.addEventListener('mouseleave', scheduleClose);
  });

  if (headerWrapper) {
    headerWrapper.addEventListener('mouseleave', scheduleClose);
  }

  nav.querySelectorAll('[data-zaoud-mega-close]').forEach((el) => {
    el.addEventListener('click', closeAll);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) closeAll();
  });

  document.addEventListener('zaoud:mega-nav:close', closeAll);
})();
